import { useFormContext } from 'react-hook-form'
import get from 'lodash/get'
import {
  ConsentRequester,
  defaultConsentStatus,
  useSub,
} from '@collegeboard-software/cm-consent-management-widget-package'
import { Spacer } from '@cb/apricot-react'
import { STUDENT_RACE_OPTIONS, STUDENT_ETHNICITY_OPTIONS } from '@myap/metadata'
import { isEmpty } from '@myap/ui-library'
import CheckboxGroupField from '../../../_common/forms/CheckboxGroupField'
import FormErrorMsg from '../../../_common/FormErrorMsg'
import { NativeAmericanAlaskanTribe } from '.'
import {
  FIELD_ETHNICITY,
  FIELD_RACE,
  ERROR_CONSENT,
  RE_COLLECTION_POINT,
  CONSENT_MAP_RE_KEY,
  CONSENT_OPT_IN,
  DATA_PROTECTED_STATES,
} from '../constants'
import consentStyles from '../consent-widget.module.scss'
import styles from '../profileandregform.module.scss'

function StudentRaceEthnicity({ disabled, stateCd, personId, setConsented, consented }) {
  const {
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext()
  const [raceEthnicityEnabled, setRaceEthnicityEnabled] = useState(
    defaultConsentStatus(RE_COLLECTION_POINT, stateCd).get(CONSENT_MAP_RE_KEY) === CONSENT_OPT_IN
  )

  //** Consent Widget Subscription **
  useSub('consent-management-consent-decision-made', async event => {
    const payloadCollectionPoint = event.payload.collectionPoint
    const attribute = event.payload.attribute.toLowerCase()
    const decision = event.payload['consent-decision']
    if (payloadCollectionPoint !== RE_COLLECTION_POINT) return
    const optedIn = decision === CONSENT_OPT_IN
    if (attribute === CONSENT_MAP_RE_KEY && consented !== optedIn) {
      setRaceEthnicityEnabled(optedIn)
      setConsented(optedIn)
    }
  })

  useEffect(() => {
    if (!raceEthnicityEnabled) {
      setValue(FIELD_ETHNICITY, [], { shouldDirty: true })
      setValue(FIELD_RACE, [], { shouldDirty: true })
    }
  }, [raceEthnicityEnabled])

  return (
    <fieldset aria-labelledby="race_ethnicity_legend" aria-required="false" aria-invalid="false">
      <legend
        id="race_ethnicity_legend"
        className={`cb-label${disabled ? ' cb-text-disabled' : ''} ${styles['legend-section']}`}
      >
        Racial/Ethnic Group
      </legend>
      <Spacer size="8" />
      {DATA_PROTECTED_STATES.includes(stateCd) ? (
        <ConsentRequester
          className={consentStyles['consent-management-widget']}
          collectionPoint={RE_COLLECTION_POINT}
          env={window.myap.env.isProduction ? 'prod' : 'nonprod'}
          personId={personId}
          stateCd={stateCd}
        />
      ) : null}
      {!isEmpty(get(errors, `${ERROR_CONSENT}.message`)) ? (
        <FormErrorMsg error={get(errors, `${ERROR_CONSENT}.message`)} />
      ) : null}
      <p className={disabled ? 'cb-text-disabled' : ''}>
        <strong>Please answer both questions about Hispanic origin and about race.</strong>
      </p>
      <p className={disabled ? 'cb-text-disabled' : ''}>
        <strong>
          For the following questions about your identity, Hispanic origins are not races.
        </strong>
      </p>
      <CheckboxGroupField
        groupName={FIELD_ETHNICITY}
        initialValues={getValues(FIELD_ETHNICITY)}
        options={STUDENT_ETHNICITY_OPTIONS}
        required={false}
        title="Are you of Hispanic, Latino, or Spanish origin?"
        disabled={disabled || !raceEthnicityEnabled}
        vertical
      />
      <Spacer size="24" />
      <CheckboxGroupField
        groupName={FIELD_RACE}
        initialValues={getValues(FIELD_RACE)}
        options={Object.values(STUDENT_RACE_OPTIONS)}
        required={false}
        title="What is your race?"
        disabled={disabled || !raceEthnicityEnabled}
        vertical
        specialHandlers={{
          [STUDENT_RACE_OPTIONS.nativeAmerican.value]: NativeAmericanAlaskanTribe,
        }}
      />
    </fieldset>
  )
}

export default StudentRaceEthnicity
